import Box from '@mui/material/Box';
import { Dialog, TextV2 } from '@insights-ltd/design-library/components';
import { Trans, useTranslation } from 'react-i18next';

export type ProfileRestoreDialogProps = {
  open: boolean;
  profileTitle: string;
  onCancel: () => void;
  onSubmit: () => void;
  restoreError: boolean;
};

const ProfileRestoreDialog = ({
  open,
  profileTitle,
  onCancel,
  onSubmit,
  restoreError,
}: ProfileRestoreDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      onSubmit={onSubmit}
      onClose={() => onCancel()}
      open={open}
      content={
        <>
          {!restoreError && (
            <Box>
              <TextV2 component="span">
                <Trans
                  i18nKey="ui.event-management.learner.profiles.restore.confirmation"
                  components={{
                    bold: <TextV2 component="span" variant="bodyBold" />,
                  }}
                  values={{ title: profileTitle }}
                />
              </TextV2>
            </Box>
          )}
          {restoreError && (
            <Box>{t('ui.event-management.learner.profiles.restore.error')}</Box>
          )}
        </>
      }
      primaryButtonText={
        !restoreError
          ? t('ui.event-management.learner.profiles.restore.submit.button')
          : ''
      }
      secondaryButtonText={
        !restoreError
          ? t('ui.event-management.learner.profiles.restore.cancel.button')
          : t(
              'ui.event-management.learner.profiles.restore.error.confirm-button',
            )
      }
      title={t('ui.event-management.learner.profiles.restore.title')}
    />
  );
};

export default ProfileRestoreDialog;
